$(document).ready(function () {
    mountVue();
});


/**
 * Register Vue.js components and initialize admin app container
 */
function mountVue() {
    // https://stackoverflow.com/a/48428907/6411973
    Vue.component('bike-listing-controls', require('../components/frontend/BikeListingControls.vue').default);
    Vue.component('bike-listing-compare-button', require('../components/frontend/BikeListingCompareButton.vue').default);
    Vue.component('bike-details-compare-button', require('../components/frontend/BikeDetailsCompareButton.vue').default);
    Vue.component('compare-top-icon', require('../components/frontend/CompareTopIcon.vue').default);
    Vue.component('compare-remove-icon', require('../components/frontend/CompareRemoveIcon.vue').default);
    Vue.component('search-box', require('../components/frontend/SearchBox.vue').default);
    Vue.component('contact-form', require('../components/frontend/ContactForm.vue').default);
    Vue.component('bike-selector', require('../components/frontend/BikeSelector.vue').default);
    Vue.component('select2', require('../components/admin/Select2.vue').default);

    window.app = new Vue({
        el: '#ec-js-vue-app',
        store: new Vuex.Store(_.merge(window.vueStore, require('./vue-store.js')) || {})
    });
}